import React, { useState } from 'react';
import toast from 'react-hot-toast';
import { useSelector } from 'react-redux';
import { placeOrder } from '../../Services/CartServices';


const useCheckout = () => {
    const { grandTotal, total_Amount } = useSelector((state) => state.checkout);

    console.log("Grand Total:", grandTotal);
    console.log("Total Amount:", total_Amount);

    const cartItems = useSelector(state => state.cart)

    const [addressId, setAddressId] = useState()
    // const [isLoading, setAddressId] = useState()

    const handleAddressId = (id) => {
        setAddressId(id);
    }

    const token = localStorage.getItem("access_token")

    const handlePayNow = async () => {
        // setIsLoading(true)

        const newCart = cartItems?.cart?.map(({ quantity, ...rest }) => ({
            ...rest,
            qty: quantity // quantity ko rename karke qty bana diya
        }));


        let body = {
            token: "tok_visa",
            payment_method: "stripe",
            shipping: "100",
            address_id: addressId,
            discount_amount: grandTotal,
            discount_type: "coupon",
            total_amount: total_Amount,
            //coupon: abc100,
            cart: newCart,
        }

        let response = await placeOrder(body)
        if (response.statusCode === 200) {
            toast?.success(response?.message)
            // setIsLoading(false)
        } else if (response.statusCode === 401) {
            toast?.error(response?.errors)
            // setIsLoading(false)
        } else {
            for (const [key, value] of Object.entries(response?.errors)) {
                toast?.error(value)
            }
            // setIsLoading(false)
        }
        // setIsLoading(false)
    }



    return {
        addressId,
        handleAddressId,
        handlePayNow
    }
}

export default useCheckout